module.exports = __webpack_public_path__ + "img/zxks-bg.5a651268.png";